<div class="container">
    <div #canvas class="diagram-container viewer" id="canvas"></div>
    <div class="diagram-properties-panel" id="propertiesPanel"></div>
</div>
